import angular from 'angular';
import template from './template.html';
import '../../linkedin/style.scss';
import '../../linkedin/select-message-template/candidate-link-profile';
import MessageFormatter from '../../../service/message-formatter';
import { EDIT_STATE, VIEW_STATE } from '../../../summernote-options';
import _ from 'lodash';
import { MESSAGE_TYPE_LINKEDIN_INMAIL } from '../../../index';

export const STATUS_SENT = 'STATUS_SENT';
export const STATUS_FAIL = 'STATUS_FAIL';
export const STATUS_SKIP = 'STATUS_SKIP';

export class SelectMessageTemplate {
    sendButtonDisabled = false;

    templateOptions = [];

    selectedTemplate = {};

    selectedTemplateIndex = 0;

    currentCandidate = {};

    currentCandidateIndex = 0;

    email = {};

    showLinkedinIcon = false;

    messageTextareaEditState = VIEW_STATE;
    subjectTextareaEditState = VIEW_STATE;

    /* @ngInject */
    constructor($scope, RouteService, $timeout, ModalDialogService) {
        this.RouteService = RouteService;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ModalDialogService = ModalDialogService;
    }

    $onChanges() {
        const { templates } = this;

        this.currentCandidate = this.getCurrentCandidate();

        if (templates) {
            this.initTemplates(templates).then((templateOptions) => {
                this.$timeout(() => {
                    this.templateOptions = templateOptions;
                    this.onTemplateChanged(templateOptions[this.selectedTemplateIndex]);
                });
            });
        }
    }

    async getApprovalLink() {
        const { result: positionApprovalLinkData } = await this.RouteService.getPositionApprovalLinks(this.position._id, {
            candidates: [{
                emails: _.get(this.currentCandidate, 'candidateData.contact.emailAddress') || [],
                talentId: _.get(this.currentCandidate, 'workflow.talentId'),
                workflowId: _.get(this.currentCandidate, 'workflow._id'),
                channelType: 'inmail',
            }],
            sentBy: 'recruiter',
        });

        return _.get(positionApprovalLinkData, '0.link', null);
    }

    async initTemplates(templates) {
        const positionApprovalLink = await this.getApprovalLink();

        const filledTemplates = templates.map((t) => {
            const formattedTemplate = MessageFormatter.fillTemplate(
                { template: t.template, subject: t.subject, name: t.name },
                { ...this.currentCandidate, positionApprovalLink },
                undefined,
                undefined,
                MESSAGE_TYPE_LINKEDIN_INMAIL,
            );

            return {
                ...t,
                formattedTemplate,
            };
        });

        return this.getMessageTemplateOptions(filledTemplates);
    }

    getCurrentCandidate() {
        return (this.candidates || [])[this.currentCandidateIndex];
    }

    getMessageTemplateOptions(messageTemplate) {
        return messageTemplate.map((template, index) => ({
            label: template.name,
            value: index,
            template,
        }));
    }

    onTemplateChanged({ template, value: index }) {
        if (this.messageTextareaEditState === EDIT_STATE) {
            this.showMessageOverrideConfirmationAlert(() => {
                this.selectedTemplate = template;
                this.selectedTemplateIndex = index;
                this.mapEmailToTokens();
                this.mapEmailToSpans();
                this.messageTextareaEditState = VIEW_STATE;
            });
        } else {
            this.selectedTemplate = template;
            this.selectedTemplateIndex = index;
            this.mapEmailToTokens();
            this.mapEmailToSpans();
            this.messageTextareaEditState = VIEW_STATE;
        }
    }

    onTemplateMessageChanged(template) {
        this.selectedTemplate = {
            ...this.selectedTemplate,
            template,
        };
    }

    onEmailChanged(message, subject) {
        this.email = {
            message: message || this.email.message,
            subject: subject || this.email.subject,
        };
    }

    skip() {
        this.onSkip();
        this.messageTextareaEditState = VIEW_STATE;
        this.subjectTextareaEditState = VIEW_STATE;
        this.openNextCandidateOrFinish();
    }

    send() {
        this.sendButtonDisabled = true;

        this.onSend({
            email: this.email,
            candidate: this.currentCandidate,
            selectedMessage: this.selectedTemplate,
        }).then(() => this.$timeout(() => this.sendButtonDisabled = false));

        this.openNextCandidateOrFinish();
    }

    openNextCandidateOrFinish() {
        const isLastCandidate = this.currentCandidateIndex + 1 === this.candidates.length;

        if (isLastCandidate) {
            this.onDone();
        } else {
            this.openNextCandidate();
        }
    }

    openNextCandidate() {
        this.currentCandidateIndex++;
        const currentCandidate = this.getCurrentCandidate();

        this.$timeout(() => {
            this.currentCandidate = currentCandidate;

            this.initTemplates(this.templates).then((templateOptions) => {
                this.templateOptions = templateOptions;
                this.onTemplateChanged(templateOptions[this.selectedTemplateIndex]);

                this.email = {
                    message: MessageFormatter.mapSpanToToken(this.selectedTemplate.template),
                    subject: MessageFormatter.mapSpanToToken(this.selectedTemplate.subject),
                };

                this.mapEmailToSpans();
            });
        });
    }

    onEditMessageStateChanged(state) {
        if (state !== this.messageTextareaEditState) {
            this.messageTextareaEditState = state;

            if (state === EDIT_STATE) {
                this.mapMessageToTokens();
            } else if (state === VIEW_STATE) {
                this.mapMessageToSpans();
            }
        }
    }

    onEditSubjectStateChanged(state) {
        if (state !== this.subjectTextareaEditState) {
            this.subjectTextareaEditState = state;

            if (state === EDIT_STATE) {
                this.mapSubjectToTokens();
            } else if (state === VIEW_STATE) {
                this.mapSubjectToSpans();
            }
        }
    }

    mapEmailToSpans() {
        const messageWithSpans = MessageFormatter.mapTokenToSpan(this.email.message);
        const subjectWithSpans = MessageFormatter.mapTokenToSpan(this.email.subject);

        if (messageWithSpans) {
            const { currentCandidate: candidate, recruiter, position } = this;
            const spansTemp = { template: messageWithSpans, subject: subjectWithSpans };
            const { template, subject } = MessageFormatter.fillTemplate(spansTemp, candidate, recruiter, position);

            this.email = {
                message: template,
                subject,
            };
            this.selectedTemplate = {
                ...this.selectedTemplate,
                template: messageWithSpans,
                subject: subjectWithSpans,
            };
        }
    }

    mapEmailToTokens() {
        this.email = {
            message: MessageFormatter.mapSpanToToken(this.selectedTemplate.template),
            subject: MessageFormatter.mapSpanToToken(this.selectedTemplate.subject),
        };
    }

    mapMessageToTokens() {
        this.email = {
            message: MessageFormatter.mapSpanToToken(this.selectedTemplate.template),
            subject: this.email.subject,
        };
    }

    mapSubjectToTokens() {
        this.email = {
            message: this.email.message,
            subject: MessageFormatter.mapSpanToToken(this.selectedTemplate.subject),
        };
    }

    mapMessageToSpans() {
        const messageWithSpans = MessageFormatter.mapTokenToSpan(this.email.message);

        if (messageWithSpans) {
            const { currentCandidate: candidate, recruiter, position } = this;
            const { template } = MessageFormatter.fillTemplate({ template: messageWithSpans }, candidate, recruiter, position);

            this.email = {
                message: template,
                subject: this.email.subject,
            };

            this.selectedTemplate = {
                ...this.selectedTemplate,
                template: messageWithSpans,
            };
        }
    }

    mapSubjectToSpans() {
        const subjectWithSpans = MessageFormatter.mapTokenToSpan(this.email.subject);

        if (subjectWithSpans) {
            const { currentCandidate: candidate, recruiter, position } = this;
            const { subject } = MessageFormatter.fillTemplate({ subject: subjectWithSpans }, candidate, recruiter, position);

            this.email = {
                message: this.email.message,
                subject,
            };

            this.selectedTemplate = {
                ...this.selectedTemplate,
                subject: subjectWithSpans,
            };
        }
    }

    showMessageOverrideConfirmationAlert(onConfirm) {
        this.ModalDialogService.showDialog({
            modalDialogId: 'BatchTemplateOverrideAlert',
            title: 'MESSAGE_OVERWIRTE_ALERT_HEADER',
            body: 'MESSAGE_OVERWIRTE_ALERT',
            showCancelButton: true,
            showCloseButton: false,
            customZIndex: 2000,
            onClose: () => {
            },
            buttons: [
                {
                    label: 'MESSAGE_OVERWIRTE_ALERT_YES',
                    className: 'primary-button',
                    onClick: () => onConfirm(),
                },
            ],
        });
    }
}

export const selectMessageTemplateConfiguration = {
    template,
    bindings: {
        candidates: '<',
        recruiter: '<',
        position: '<',
        templates: '<',
        onSend: '&',
        onSkip: '&',
        onClose: '&',
        onDone: '&',
    },
    controller: SelectMessageTemplate,
    controllerAs: 'selectMessageTemplateCtrl',
};

angular.module('TALENYA-FE')
    .component('selectLinkedinInmailTemplate', selectMessageTemplateConfiguration);
